// @ts-nocheck
import html2canvas from 'html2canvas';
// @ts-ignore
import { jsPDF } from 'jspdf/dist/jspdf.es';
import React, { useState } from 'react';
import { ButtonUI, Loader } from 'sonata-react-components';

import './reportingInsightsExporter.scss';

import { reportingHeaderActuator, selectedMetricToMapTotals, stylesForActionableItems } from './actionables.helper';

type ButtonUIProps = React.ComponentProps<typeof ButtonUI>;
type Props = {
  buttonProps: ButtonUIProps;
  defaultFileName?: string;
  elementTargetId: string;
  onTogglePDFLoading?: (val: boolean) => void;
};

const ReportingInsightsExporter: React.VFC<Props> = props => {
  const { buttonProps, defaultFileName = 'download', elementTargetId, onTogglePDFLoading } = props;

  const [{ loading }, setState] = useState({
    loading: false
  });

  const pdfReportingActionables = async (printing: boolean) => {
    await reportingHeaderActuator(printing ? 'show' : 'hide');
    stylesForActionableItems(printing ? 'add' : 'remove');
    selectedMetricToMapTotals(printing ? 'add' : 'hide');
  };

  const printCharts = async () => {
    await pdfReportingActionables(true);
    onTogglePDFLoading?.(true);
    setState({ loading: true });
    const reportingChartsDiv = document.getElementById(elementTargetId);
    html2canvas(reportingChartsDiv!, {
      height: reportingChartsDiv!.clientHeight,
      imageTimeout: 0,
      useCORS: true,
      width: reportingChartsDiv!.clientWidth
    })
      .then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'pt', [canvas.width, canvas.height]);

        const topLeftMargin = 8;

        const width = pdf.internal.pageSize.getWidth();
        const height = pdf.internal.pageSize.getHeight();

        const widthRatio = width / canvas.width;
        const heightRatio = height / canvas.height;
        const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;

        pdf.addImage(
          imgData,
          'JPEG',
          topLeftMargin,
          topLeftMargin,
          canvas.width * ratio,
          canvas.height * ratio,
          undefined,
          'SLOW'
        );
        pdf.save(`${defaultFileName}.pdf`);
      })
      .finally(() => {
        pdfReportingActionables(false);
        setState({ loading: false });
        onTogglePDFLoading?.(false);
      });
  };

  return (
    <>
      <ButtonUI
        id="reportingHeader-downloadButtons-sonataReport"
        key="reportingHeader-downloadButtons-sonataReport"
        loading={loading}
        onClick={printCharts}
        {...buttonProps}
      />
      {loading && (
        <div className="reportingDownloadPDFSpinner">
          <Loader showBackground type="landing" variant="default" />
        </div>
      )}
    </>
  );
};

export default ReportingInsightsExporter;
